import React, { useContext } from "react";
import { Pagination, Stack } from "@mui/material";
import { Context } from "../provider";

const CreditNotesPagination = () => {
    const context = useContext(Context);

    return(
        <>
            {!context.state.is_loading ? (
                <Stack 
                    spacing={2} 
                    className="mb-3" 
                    style={{
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'center'
                    }}      
                >
                    <Pagination 
                        count={context.state.total_pages} 
                        page={context.state.current_page_si} 
                        onChange={(event, newPage) => context.dispatch({
                            type: 'SET_CURRENT_PAGE',
                            current_page: newPage
                        })}
                    />
                </Stack>
            ) : null }
        </>
    );
}

export default CreditNotesPagination;